import { BaseMapper } from '@ps/utils';
import {
  BuyerQualificationDto,
  QualificationLocalizationDto,
} from '../dtos/decipher-mapping.dto';
import {
  BuyerQualification,
  QualificationLocalization,
} from '../../state/decipher/decipher-mapping-state.model';

export class DecipherQualificationMapper extends BaseMapper<
  BuyerQualificationDto,
  BuyerQualification
> {
  public override fromDto(dto: BuyerQualificationDto): BuyerQualification {
    return {
      qualificationCode: dto.qualification_code,
      type: dto.type,
      description: dto.desc,
      localizations: dto.localizations.map((localization) =>
        this._mapLocalization(localization),
      ),
    };
  }

  private _mapLocalization(
    dto: QualificationLocalizationDto,
  ): QualificationLocalization {
    return {
      locale: dto.locale,
      answers: dto.answers.map((answer) => ({
        answerId: answer.answer_id,
        localText: answer.local_text,
        engText: answer.eng_text,
        conditionCode: answer.condition_code,
      })),
      format: {
        min: dto.format?.min ?? null,
        max: dto.format?.max ?? null,
        regex: dto.format?.regex ?? '',
      },
    };
  }
}
